ele.date = (function(){	
	
	return {
		/** returns formatted date from Date object example format: "16th May 2014" */
		formatDate: function(d) {
			var date = this.parseDate(d, false);
			return [date.getDate() + this.getOrdinal(date.getDate())
			       , i18n('month_' + date.getMonth())
			       , date.getFullYear()].join(" ");
		},

		/** returns formatted date from Date object example format: "Mon 16th May 2014" */
		formatFriendlyDate: function(d) {
			var date = this.parseDate(d, false);
			return i18n('day_'+date.getDay()) + " " + date.getDate() + this.getOrdinal(date.getDate()) + " " + i18n('month_long_' + date.getMonth()) + " " + date.getFullYear();
		},

		/** returns tiny date from Date object: 23 Nov */
		formatMiniDate: function(d) {
			var date = this.parseDate(d, false);
			return ele.math.zerofill(date.getDate(), 2) + " " + i18n('month_' + date.getMonth());
		},

        /** returns suitable format date from Date object: 03/12/2014 */
        formatDateFieldDate: function(d) {
            var date = this.parseDate(d, false);
            if (this.isUSDate()) {
                return [ele.math.zerofill(date.getMonth()+1, 2), "/"
                    ,ele.math.zerofill(date.getDate(), 2), "/"
                    , date.getFullYear()].join("");
            } else {
                return [ele.math.zerofill(date.getDate(), 2), "/"
                    , ele.math.zerofill(date.getMonth()+1, 2), "/"
                    , date.getFullYear()].join("");
            }
        },

        /** returns suitable format date from Date object: 2014-12-30 */
        formatDateForServer: function(d) {
            var date = this.parseDate(d, false);

                return [ date.getFullYear()
                    , ele.math.zerofill(date.getMonth()+1, 2)
                    , ele.math.zerofill(date.getDate(), 2)].join("-");
        },

		/** returns formatted date and time from Date object */
		formatDateTime: function(d, includeSeconds) {
			var date = this.parseDate(d, true);
			if(ele.config.usersession.timezoneDisplaySwitch){
				return [date.getDate() + this.getOrdinal(date.getDate())
				       , i18n('month_' + date.getMonth())
				       , date.getFullYear()
				       , this.formatTime(d, includeSeconds)
				       , i18n("js_" + ele.config.usersession.timeZoneName)].join(" ");
			} else {
				return [date.getDate() + this.getOrdinal(date.getDate())
				       , i18n('month_' + date.getMonth())
				       , date.getFullYear()
				       , this.formatTime(d, includeSeconds)].join(" ");		
			}       
		},

		/** returns formatted time from Date object */
		formatTime: function(d, includeSeconds, offset = true) {
			var date = this.parseDate(d, offset);
			var time = [ele.math.zerofill(date.getHours(), 2)
			       , ele.math.zerofill(date.getMinutes(), 2)]
			if (includeSeconds) time.push(ele.math.zerofill(date.getSeconds(), 2));
			return time.join(":");
		},
		
		/** returns formatted date from Date object example format: "YYYY/MM/DD" */
		reverseDate: function(d, dateFormat) {

			if (!d) { return ""; }
			var parts = d.split("/");
			var dd = +parts[0];
			var mm = +parts[1];
			var yyyy = +parts[2];

			if (dateFormat != null && dateFormat == "mdy") {
				//'Murica date
				var temp = dd;
				dd = mm;
				mm = temp;
			}
			
			var date = new Date(yyyy, mm - 1, dd);
			
			return [date.getFullYear()
			       , ele.math.zerofill(date.getMonth()+1, 2)
			       , ele.math.zerofill(date.getDate(), 2)].join("/");
		},
		
		/** flip format YY/MM/DD to DD/MM/YYYY */
		flipReverseDate:function(d, dateFormat) {
			
			if (!d) { return ""; }
			// Split date and time if time is present
			var parts = d.split(" ");
			var datePart = parts[0];
			var timePart = parts.length > 1 ? " " + parts[1] : "";
			var ds = datePart.split("/");
			if (ds.length != 3) return "";
			if (dateFormat != null && dateFormat == "mdy") {
				//'Murica date
				return ds[1] + "/" + ds[2] + "/" + ds[0] + timePart;
			} else {
				return ds[2] + "/" + ds[1] + "/" + ds[0] + timePart;
			}
		},
		
		getOrdinal: function(number) {
			
			if (this.isUSDate()) return "";
			
			var str = number.toString();

			if(!str.length)
				throw new Error("No number supplied");

			// Eleven, twelve... etc are all "th"
			// if it is not one of these numbers
			// (that includes numbers in the hundreds
			// and thousands... etc.) then add the
			// correct ordinal 
			if (str.length < 2 || str[str.length - 2] != "1") {
				
				var last = str[str.length - 1];
				
				if(last == "1") {
					return "st";
				} else if(last == "2") {
					return "nd";
				} else if(last == "3") {
					return "rd";
				}
			}
			
			return "th";
		},

		isPossibleDate: function(day, month, year){

		},
		
		isValidDate: function(str, dateFormat, inputOutputDiff = false) {
			/*
				inputOutputDiff is because this function would return 21/02/1933 as a valid date because it resolves it to 02/03/1933. 
				Lots of validation functions call isValidDate before they run their specific validation, so when we started checking 
				wether a date output matched the input it fired incorrect validation messages on failure. Rather than refactor the function
				and those who call the function, we simply put a check around wether the old or new response was used. 
			*/
			let day = 0;
			let month = 0;
			let year = 0;
			var defaultDateFormat = (ele.config && ele.config.usersession && ele.config.usersession.dateformat) || 'dd/mm/yyyy';
			// Define a regular expression to match "yyyy" in the year position
			const regexYear = /yyyy/g;
			const regexDay = /dd/g;
			const regexMonth = /mm/g;
			// Use the replace() method of the string to replace various formats with the format accepted by jquery datepicker, no leading 0s and yy for long year format
			defaultDateFormat = defaultDateFormat.replace(regexYear, "yy");			
			defaultDateFormat = defaultDateFormat.replace(regexDay, "d");
			defaultDateFormat = defaultDateFormat.replace(regexMonth, "m");

			// This argument usually comes from Rapidocs, it is dmy for UK so needs to be handled if we branch to a third format
		    if (dateFormat === "mdy") {
                defaultDateFormat = "m/d/yy";
            }
		    if (dateFormat === "dmy") {
                defaultDateFormat = "d/m/yy";
            }						
			// Currently we are handling only US and UK date formats with a / as the seperator but we can obviously extend it here if we were to use Quebec format for example.
			if (defaultDateFormat === "m/d/yy") {
				const dateSplit = str.split('/');
				day = dateSplit[1];
				month = dateSplit[0] - 1;
				year = dateSplit[2]; 
				str = new Date(year,month,day); 			
				consolodatedDate = `${str.getMonth() + 1}/${str.getDate()}/${str.getFullYear()}`;
            } else {			
				const dateSplit = str.split('/');
				day = dateSplit[0];
				month = dateSplit[1] - 1;
				year = dateSplit[2];
				str = new Date(year,month,day); 							
				consolodatedDate = `${str.getDate()}/${str.getMonth() + 1}/${str.getFullYear()}`;
            }

            try {
				if(inputOutputDiff){
					// If the formatted date string is the same as the input, the date is valid
					let tempDay = str.getDate();
					let leadingZeroDay = tempDay < 10 ? '0' + tempDay : '' + tempDay;
					return leadingZeroDay == day && str.getMonth() == month && str.getFullYear() == year;		
				} else {
					return $.datepicker.parseDate(defaultDateFormat, consolodatedDate);
				}
            } catch (e) {
				console.log(e)
		        return false;
            }
		},

		/** parsing dates */
		parseDate: function(str, offset) {
			if (str instanceof Date) {
                if (offset) {
                    return new Date(this.offset(str.getTime()));
                } else {
                    return new Date(str.getTime());
                }
			}
			str = str.trim();
			
			//remove items after full stop e.g. 2016-02-11 12:11:30.76
			str = str.split(".")[0];
			
			//var ts = Date.parse(str);
			var ts;
			if (str.indexOf("/") > -1) {
				var parts = str.split("/");
				var dd = +parts[0];
				var mm = +parts[1];
				var yyyy = +parts[2];
				
				ts = new Date(yyyy, mm - 1, dd).getTime();
			} else {
				ts = Date.parse(str);
			}
			if (isNaN(ts)) {
				ts = Date.parse(str.replace(/[^\d\s:\/-]/g, ""));
			}
			// IE8 cannot parse hyphens
			if (isNaN(ts)) {
				ts = Date.parse(str.replace(/-/g, "/"));
			}
			// Could return NaN
            if (offset) {
                return new Date(this.offset(ts));
            } else {
                return new Date(ts);
            }
		},
		
		offset: function(timestamp) {
  			
			// The offset should be provided in milliseconds
			var Timestamp = timestamp - (ele.config.usersession.timezoneoffset * -1);
			return Timestamp;
		},

        //may need refining
        isUSDate: function() {
            return ele.config.usersession.dateformat === "mm/dd/yy";
        }
		
	}

})();

//not sure where else to put this, but since it's date related, set datepicker defaults according to language
$(document).ready(function() {
    // put all your jQuery goodness in here.
    //default is English so only need to set if another language
    if (ele.config.languageid === 2) {
        $.datepicker.regional['fr'] = {
            clearText: 'Effacer', clearStatus: '',
            closeText: 'Fermer', closeStatus: 'Fermer sans modifier',
            prevText: 'Préc', prevStatus: 'Voir le mois précédent',
            nextText: 'Suiv', nextStatus: 'Voir le mois suivant',
            currentText: 'Courant', currentStatus: 'Voir le mois courant',
            monthNames: ['Janvier','Février','Mars','Avril','Mai','Juin',
                'Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
            monthNamesShort: ['Jan','Fév','Mar','Avr','Mai','Jun',
                'Jul','Aoû','Sep','Oct','Nov','Déc'],
            monthStatus: 'Voir un autre mois', yearStatus: 'Voir un autre année',
            weekHeader: 'Sm', weekStatus: '',
            dayNames: ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'],
            dayNamesShort: ['Dim','Lun','Mar','Mer','Jeu','Ven','Sam'],
            dayNamesMin: ['Di','Lu','Ma','Me','Je','Ve','Sa'],
            dayStatus: 'Utiliser DD comme premier jour de la semaine', dateStatus: 'Choisir le DD, MM d',
            dateFormat: 'mm/dd/yy', firstDay: 0,
            initStatus: 'Choisir la date', isRTL: false};
        $.datepicker.setDefaults($.datepicker.regional['fr']);

    }

});
